import UpdateOnPaymentSuccess from "seneca-common/features/subscriptions/state/models/subscriptions/subscription/UpdateOnPaymentSuccess";

export function getSubscriptionProductId(state: UpdateOnPaymentSuccess) {
  return state.subscriptionProductId;
}

export function getProratedPrice(state: UpdateOnPaymentSuccess) {
  return state.proratedPrice;
}
